// Bullet holes: small dark quads on the surface that was hit, newest replacing oldest.

import * as THREE from 'three';
import { sourceToThree } from './coords';

const MAX = 64;
const SIZE = 3.5;

function holeTexture() {
  const c = document.createElement('canvas');
  c.width = c.height = 32;
  const g = c.getContext('2d')!;
  const grad = g.createRadialGradient(16, 16, 0, 16, 16, 16);
  grad.addColorStop(0, 'rgba(10,10,10,0.95)');
  grad.addColorStop(0.35, 'rgba(25,22,20,0.85)');
  grad.addColorStop(0.6, 'rgba(60,55,50,0.35)');
  grad.addColorStop(1, 'rgba(60,55,50,0)');
  g.fillStyle = grad;
  g.fillRect(0, 0, 32, 32);
  return new THREE.CanvasTexture(c);
}

export class Decals {
  readonly group = new THREE.Group();
  private readonly meshes: THREE.Mesh[] = [];
  private next = 0;
  private readonly n = new THREE.Vector3();

  constructor() {
    const mat = new THREE.MeshBasicMaterial({
      map: holeTexture(),
      transparent: true,
      depthWrite: false,
      polygonOffset: true,
      polygonOffsetFactor: -4,
    });
    const geo = new THREE.PlaneGeometry(SIZE, SIZE);
    for (let i = 0; i < MAX; i++) {
      const m = new THREE.Mesh(geo, mat);
      m.visible = false;
      m.renderOrder = 2;
      this.meshes.push(m);
      this.group.add(m);
    }
  }

  /** Add a hole at a Source-space point with the surface's Source-space normal. */
  add(pos: readonly number[], normal: readonly number[]) {
    const m = this.meshes[this.next];
    this.next = (this.next + 1) % MAX;
    sourceToThree(this.n, normal[0], normal[1], normal[2]);
    sourceToThree(m.position, pos[0] + normal[0] * 0.2, pos[1] + normal[1] * 0.2, pos[2] + normal[2] * 0.2);
    m.lookAt(m.position.x + this.n.x, m.position.y + this.n.y, m.position.z + this.n.z);
    m.rotateZ(Math.random() * Math.PI * 2);
    m.visible = true;
  }

  clear() {
    for (const m of this.meshes) m.visible = false;
  }
}
